import { useFormContext, useWatch } from 'react-hook-form'

import { useSubmitButtonLabel } from '../../../helpers/useSubmitButtonLabel'
import { TOrderForm } from '../contexts/FormProvider'

type TOptions = {
  isMobile: boolean
}
/**
 * returns a label for the submit button based on the selected payment method
 */
export const useFormSubmitButtonLabel = ({ isMobile }: TOptions) => {
  const { control } = useFormContext<TOrderForm>()
  const paymentMethod = useWatch({ control, name: `paymentMethod` })

  return useSubmitButtonLabel({ isMobile, paymentMethod })
}
